import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  loadAPI: Promise<any>;

  constructor(private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute, private router: Router) {

  }


  ngOnInit() {
   // this.loadScript();
   this.reloadIfNecessary();
  }

  reloadIfNecessary() {
    if (!localStorage.getItem('IsLoadedBefore')) { 
      localStorage.setItem('IsLoadedBefore', 'no reload') 
      location.reload() 
    } else {
      localStorage.removeItem('IsLoadedBefore') 
    }
  }

  public loadScript() {
    this.spinner.show();
    var isFound = false;
    var scripts = document.getElementsByTagName("script")
    for (var i = 0; i < scripts.length; ++i) {
      if (scripts[i].getAttribute('src') != null && scripts[i].getAttribute('src').includes("loader")) {
        isFound = true;
      }
    }
    if (!isFound) {
      var dynamicScripts = ["https://dropinblog.com/js/embed.js"];

      for (var i = 0; i < dynamicScripts.length; i++) {
        let node = document.createElement('script');
        node.src = dynamicScripts[i];
        node.type = 'text/javascript';
        node.async = false;
        node.charset = 'utf-8';
        document.getElementsByTagName('head')[0].appendChild(node);
      }
    }
    this.spinner.hide();
  }
}
